import React, { Fragment, useMemo, useRef } from 'react';
import L from 'leaflet';
import * as Leaflet from 'react-leaflet';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import { Spin } from 'antd';
import MarkerAsset from '@bvt-features/tenant-suitability/assets/marker-asset.png';
import MarkerBlack from '@bvt-features/tenant-suitability/assets/marker-black.png';
import MarkerPotentialAsset from '@bvt-features/tenant-suitability/assets/marker-potential-asset.png';
import MarkerShadow from '@bvt-features/tenant-suitability/assets/marker-shadow.png';

export function Marker(props) {
  const {
    children,
    draggable,
    position,
    setPosition,
    loading,
    iconName,
  } = props;
  const markerRef = useRef(null);

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker !== null) {
          setPosition && setPosition(marker.getLatLng());
        }
      },
    }),
    []
  );

  const markerLoading = new L.DivIcon({
    html: renderToStaticMarkup(<Spin />),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [8, -34],
    shadowSize: [41, 41],
  });

  const marker = L.icon({
    // eslint-disable-next-line no-nested-ternary
    iconUrl: !iconName ? MarkerBlack : (iconName === 'asset' ? MarkerAsset : MarkerPotentialAsset),
    iconSize: [25, 41],
    iconAnchor: [12, 41],

    shadowUrl: MarkerShadow,
    shadowSize: [22, 10],
    shadowAnchor: [11, -2]
  });

  const iconTSA = loading ? markerLoading : marker;

  return (
    <Fragment>
      {position && (
        <Leaflet.Marker
          draggable={draggable}
          eventHandlers={eventHandlers}
          icon={iconTSA}
          position={position}
          ref={markerRef}
        >
          {!!children && (
            <Leaflet.Popup closeButton={false}>{children}</Leaflet.Popup>
          )}
        </Leaflet.Marker>
      )}
    </Fragment>
  );
}

Marker.defaultProps = {
  children: null,
  colorIcon: 'currentColor',
  draggable: false,
  iconName: 'DefaultPoi',
  position: null,
};

Marker.propTypes = {
  children: PropTypes.node,
  colorIcon: PropTypes.string,
  draggable: PropTypes.bool,
  iconName: PropTypes.string,
  position: PropTypes.array,
  setPosition: PropTypes.func,
};
